/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import React, { useEffect } from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SearchIcon from '@mui/icons-material/Search';
import YesNoSwitch from 'components/input/YesNoSwitch';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import TemplateScore from './components/TemplateScore';
import {
  BoolToString,
  checkEnableParseJSON,
  formatBoolean,
  optionValues,
  optionValues2,
  setArrayLength,
} from 'components/helper/helper';
import DatePickerInput from 'components/input/DatePicker';
import { getACTTest, updateACTTest } from 'app/testingSlice/testingSlice';
import { debounce } from 'lodash';
import ACTItem from './components/ACTItem';
import Grid from '@mui/joy/Grid';
import { ModalCheckTestFields } from '../common/ModalCheckTestFields';
import { scrollToObject } from 'components/helper/ui_helper';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

const ACTSampleItem = {
  test_date: '',
  composite_score: '',
  english: '',
  mathematics: '',
  reading: '',
  science: '',
  writing: '',
};

const createValidationSchema = () => {
  return Yup.object().shape({
    future_testing_date_1: Yup.object().shape({
      test1: Yup.string().nullable(),
      test2: Yup.string().nullable(), 
      test3: Yup.string().nullable(),
    })
  });
};

const ACTTest = () => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing:any = useAppSelector((store) => store.testing);
  const dispatch:any = useAppDispatch();
  const history:any = useHistory();
  const location:any = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(useLocation().search);
  const [check, setCheck] = React.useState(query.get('check'));
  const [showModal, setShowModal] = React.useState(false);
  const [testData, setTestData] = React.useState<any>(null);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.ACT_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  let checkIndex = query.get('index');

  const formik = useFormik({
    initialValues: {
      act_id_number: 0,
      csu_info: {
        act_score: [],
      },
      is_have_act_score_report: '',                         
      have_taken_act_plus_writing_test: 'true',       //Have you taken the ACT Plus Writing test ?
      number_of_act_score_report: 0,
      superscore_calculated_by_act: 0,
      highest_composite_score: 0,
      highest_composite_score_sub: 0,
      highest_composite_test_day: '',
      highest_english_score: 0,
      highest_english_score_sub: 0,
      highest_english_test_day: '',
      highest_mathematic_score: 0,
      highest_mathematic_score_sub: 0,
      highest_mathematic_test_day: '',
      highest_reading_score: 0,
      highest_reading_score_sub: 0,
      highest_reading_test_day: '',
      highest_science_score: 0,
      highest_science_score_sub: 0,
      highest_science_test_day: '',
      highest_writing_score: 0,
      highest_writing_score_sub: 0,
      highest_writing_test_day: '',
      future_act_test_plan_to_take: 0,
      future_testing_date_1: {
        test1: '',
        test2: '',
        test3: '',
      },

      //Would you like to report your highest ACT Science score? 
      is_report_highest_act_science_score: 'true',

      // Would you like to report your highest ACT Writing score? 
      is_report_highest_act_writing_score: 'true',

    },
    validate: (values) => {
      const errors: any = {};
      
      // Validate ACT test dates manually
      if (values.csu_info?.act_score?.length > 0) {
        values.csu_info.act_score.forEach((actTest: any, index: number) => {
          if (!actTest.test_date) {
            if (!errors.csu_info) errors.csu_info = {};
            if (!errors.csu_info.act_score) errors.csu_info.act_score = [];
            if (!errors.csu_info.act_score[index]) errors.csu_info.act_score[index] = {};
            errors.csu_info.act_score[index].test_date = 'Test date is required';
          } else if (!moment(actTest.test_date).isValid()) {
            if (!errors.csu_info) errors.csu_info = {};
            if (!errors.csu_info.act_score) errors.csu_info.act_score = [];
            if (!errors.csu_info.act_score[index]) errors.csu_info.act_score[index] = {};
            errors.csu_info.act_score[index].test_date = 'Invalid date';
          } else {
            const year = moment(actTest.test_date).year();
            if (year.toString().length !== 4) {
              if (!errors.csu_info) errors.csu_info = {};
              if (!errors.csu_info.act_score) errors.csu_info.act_score = [];
              if (!errors.csu_info.act_score[index]) errors.csu_info.act_score[index] = {};
              errors.csu_info.act_score[index].test_date = 'Invalid date';
            }
          }
        });
      }
      
      // Validate basic schema for other fields
      try {
        createValidationSchema().validateSync(values, { abortEarly: false });
      } catch (error: any) {
        if (error.inner) {
          error.inner.forEach((err: any) => {
            const path = err.path;
            if (path) {
              const keys = path.split('.');
              let current = errors;
              for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) current[keys[i]] = {};
                current = current[keys[i]];
              }
              current[keys[keys.length - 1]] = err.message;
            }
          });
        }
      }
      
      // Custom validation for future testing dates
      const futureTestPlan = values.future_act_test_plan_to_take;
      
      // Validate test1
      if ([1, '1', '2', '3', 2, 3].includes(futureTestPlan)) {
        const test1Value = values.future_testing_date_1?.test1;
        if (!test1Value) {
          if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
          errors.future_testing_date_1.test1 = 'Future testing date is required';
        } else {
          if (!moment(test1Value).isValid()) {
            if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
            errors.future_testing_date_1.test1 = 'Invalid date';
          } else {
            const year = moment(test1Value).year();
            if (year.toString().length !== 4) {
              if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
              errors.future_testing_date_1.test1 = 'Invalid date';
            }
          }
        }
      }
      
      // Validate test2
      if (['2', '3', 2, 3].includes(futureTestPlan)) {
        const test2Value = values.future_testing_date_1?.test2;
        if (!test2Value) {
          if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
          errors.future_testing_date_1.test2 = 'Future testing date is required';
        } else {
          if (!moment(test2Value).isValid()) {
            if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
            errors.future_testing_date_1.test2 = 'Invalid date';
          } else {
            const year = moment(test2Value).year();
            if (year.toString().length !== 4) {
              if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
              errors.future_testing_date_1.test2 = 'Invalid date';
            }
          }
        }
      }
      
      // Validate test3
      if (['3', 3].includes(futureTestPlan)) {
        const test3Value = values.future_testing_date_1?.test3;
        if (!test3Value) {
          if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
          errors.future_testing_date_1.test3 = 'Future testing date is required';
        } else {
          if (!moment(test3Value).isValid()) {
            if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
            errors.future_testing_date_1.test3 = 'Invalid date';
          } else {
            const year = moment(test3Value).year();
            if (year.toString().length !== 4) {
              if (!errors.future_testing_date_1) errors.future_testing_date_1 = {};
              errors.future_testing_date_1.test3 = 'Invalid date';
            }
          }
        }
      }
      
      return errors;
    },
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        student_id: studentId,
        csu_info: JSON.stringify(values.csu_info),
        have_taken_act_plus_writing_test: formatBoolean(values.have_taken_act_plus_writing_test),
        future_testing_date_1: JSON.stringify(values.future_testing_date_1),
        is_report_highest_act_science_score: formatBoolean(values.is_report_highest_act_science_score),
        is_report_highest_act_writing_score: formatBoolean(values.is_report_highest_act_writing_score),
      };
      await dispatch(updateACTTest(newValues));
    },
  });

  useEffect(() => {
    const actScores = formik.values.csu_info?.act_score || [];
    if (actScores.length === 0) return;

    let highestCompositeScore = 0;
    let highestCompositeTestDay = '';
    let highestEnglishScore = 0;
    let highestEnglishTestDay = '';
    let highestMathematicScore = 0;
    let highestMathematicTestDay = '';
    let highestReadingScore = 0;
    let highestReadingTestDay = '';
    let highestScienceScore = 0;
    let highestScienceTestDay = '';
    let highestWritingScore = 0;
    let highestWritingTestDay = '';

    actScores.forEach((item: any) => {
      const compositeScore = parseInt(item.composite_score) || 0;
      const englishScore = parseInt(item.english) || 0;
      const mathematicsScore = parseInt(item.mathematics) || 0;
      const readingScore = parseInt(item.reading) || 0;
      const scienceScore = parseInt(item.science) || 0;
      const writingScore = parseInt(item.writing) || 0;

      if (compositeScore > highestCompositeScore && item.test_date) {
        highestCompositeScore = compositeScore;
        highestCompositeTestDay = item.test_date;
      }

      if (englishScore > highestEnglishScore && item.test_date) {
        highestEnglishScore = englishScore;
        highestEnglishTestDay = item.test_date;
      }

      if (mathematicsScore > highestMathematicScore && item.test_date) {
        highestMathematicScore = mathematicsScore;
        highestMathematicTestDay = item.test_date;
      }

      if (readingScore > highestReadingScore && item.test_date) {
        highestReadingScore = readingScore;
        highestReadingTestDay = item.test_date;
      }

      if (scienceScore > highestScienceScore && item.test_date) {
        highestScienceScore = scienceScore;
        highestScienceTestDay = item.test_date;
      }

      if (
        writingScore > highestWritingScore &&
        item.test_date &&
        formik.values.have_taken_act_plus_writing_test === 'true'
      ) {
        highestWritingScore = writingScore;
        highestWritingTestDay = item.test_date;
      }
    });

    let newValues = Object.assign({}, formik.values);

    newValues.highest_composite_score = highestCompositeScore;
    newValues.highest_composite_score_sub = highestCompositeScore;
    newValues.highest_composite_test_day = highestCompositeTestDay;

    newValues.highest_english_score = highestEnglishScore;
    newValues.highest_english_score_sub = highestEnglishScore;
    newValues.highest_english_test_day = highestEnglishTestDay;

    newValues.highest_mathematic_score = highestMathematicScore;
    newValues.highest_mathematic_score_sub = highestMathematicScore;
    newValues.highest_mathematic_test_day = highestMathematicTestDay;

    newValues.highest_reading_score = highestReadingScore;
    newValues.highest_reading_score_sub = highestReadingScore;
    newValues.highest_reading_test_day = highestReadingTestDay;

    newValues.highest_science_score = highestScienceScore;
    newValues.highest_science_score_sub = highestScienceScore;
    newValues.highest_science_test_day = highestScienceTestDay;

    if (formik.values.have_taken_act_plus_writing_test === 'true') {
      newValues.highest_writing_score = highestWritingScore;
      newValues.highest_writing_score_sub = highestWritingScore;
      newValues.highest_writing_test_day = highestWritingTestDay;
    }
    formik.setValues(newValues);

  }, [formik.values.csu_info?.act_score, formik.values.have_taken_act_plus_writing_test]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('actTest') && testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const AutoScrollAndExpand = () => {
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      // /console.log('hash:', hash);
      if (hash) {
        switch(hash) {
          case 'have_taken_act_plus_writing_test':
          case 'is_report_highest_act_science_score':
          case 'is_report_highest_act_writing_score':
          case 'future_act_test_plan_to_take':
          case 'future_testing_date_1_test1':
          case 'future_testing_date_1_test2':
          case 'future_testing_date_1_test3':
            setTimeout(() => {
              scrollToObject(hash, 200);
            }, 1000);
            break;
        }
      }

      //#region scroll to and expand fold
      checkIndex = query.get('index');
      if (checkIndex) {
        setTimeout(() => {
          scrollToObject(`fold_${checkIndex}`, 200);
        }, 500);

        if (formik.values.csu_info?.act_score && formik.values.csu_info?.act_score.length>0) {
          expandFold(Number(checkIndex), formik.values.csu_info?.act_score.length);
        }
      }     
      //#endregion
  
    }
    catch(ex){
      console.log('Error:', ex);
    }
  }

  useEffect(() => {
    AutoScrollAndExpand();
  }, [location]);

  const expandFold = (num: number, len: number) => {
    let id = `#btn_fold_${num}_${len}[aria-expanded="false"]`;
    let dv: any = document.querySelector(id);
    if (dv) dv.click();
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.ACT_TEST
      );
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }

      let res = await dispatch(getACTTest(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = {
          ...dataLoaded,
          csu_info: {
            ...formik.values.csu_info,
            ...checkEnableParseJSON(dataLoaded.csu_info),
          },
          is_have_act_score_report: BoolToString(dataLoaded.is_have_act_score_report ?? 'true'),
          have_taken_act_plus_writing_test: BoolToString(dataLoaded.have_taken_act_plus_writing_test),
          future_testing_date_1: checkEnableParseJSON(dataLoaded.future_testing_date_1, {
            test1: '',
            test2: '',
            test3: '',
          }),
          is_report_highest_act_science_score: BoolToString(dataLoaded.is_report_highest_act_science_score ?? 'true'),
          is_report_highest_act_writing_score: BoolToString(dataLoaded.is_report_highest_act_writing_score ?? 'true')    
        };

        formik.resetForm({ values: values });
        setTestData(values);
        AutoScrollAndExpand();
      }
      setLoading(false);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);


  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //#region Auto save function ==========
  React.useEffect(() => {
    if (formik.dirty) {
      setTestData(formik.values);
      debounceSaving();
    }
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  //#endregion Auto save function ==========

  const handleCheckMissing = () => {
    setCheck('1');
    setTestData(formik.values);
    setShowModal(true);
  }

  const handleCloseModal = () => {
    setShowModal(false);
    AutoScrollAndExpand();
  };


  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'General', percentOnProcess: 25 },
          { title: 'Composite', percentOnProcess: 33 },
          { title: 'English', percentOnProcess: 41 },
          { title: 'Math', percentOnProcess: 50 },
          { title: 'Reading', percentOnProcess: 60 },
          { title: 'Science', percentOnProcess: 70 },
          { title: 'Writing', percentOnProcess: 80 },
          { title: 'Future ACT', percentOnProcess: 90 },
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                ACT Tests
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className="my-2">Let's put all your ACT testing information in one place!</div>
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <SelectInput
                  className="common-flag end-flag"
                  form={formik}
                  option={optionValues(Array.from(Array(6).keys()))}
                  label="Number of past ACT scores you wish to report*"
                  dataUp="act-number-scores"
                  name="number_of_act_score_report"
                  values={formik.values.number_of_act_score_report}
                  isMissing={formik.values.number_of_act_score_report === null && check}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue(
                      'csu_info.act_score',
                      setArrayLength(
                        formik.values.csu_info?.act_score ?? [],
                        e.target.value,
                        ACTSampleItem
                      )
                    );
                  }}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  type="number"
                  max={999999999}
                  name="act_id_number"
                  values={formik.values.act_id_number}
                  onChange={formik.handleChange}
                  label="ACT ID number"
                  disabled={reviewedAndComplete}
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  id="have_taken_act_plus_writing_test"
                  className="mb-3"
                  label="Have you taken the ACT Plus Writing test?*"
                  logo="span-cm-logo"
                  name="have_taken_act_plus_writing_test"
                  values={formik.values.have_taken_act_plus_writing_test}
                  onChange={(e: any) => {
                    formik.setFieldValue('have_taken_act_plus_writing_test', e.target.value);
                    if (e.target.value === 'false') {
                      formik.setFieldValue('is_report_highest_act_writing_score', 'false');
                    }
                  }}
                  isMissing={!formik.values.have_taken_act_plus_writing_test && check}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              <div className="w-100 bg-white py-2 px-2 rounded-3">
                {(formik.values.csu_info?.act_score ?? []).map((item, index) => {
                  return (
                    <Grid xs={12} key={index} spacing={1}>
                      <ACTItem form={formik} index={index} check={check} checkIndex={checkIndex} />
                    </Grid>
                  );
                })}
              </div>

              <Grid xs={12}>
                <div className="text-field-light my-3"></div>
              </Grid>

              <Grid xs={12}>
                <div className={`${isMobile ? 'fs-6' : 'fs-5'} p-1 span-cm-logo mt-3`}>Super Score</div>
              </Grid>

              {/* <SelectInput
                option={optionValues2(37).reverse()}
                className="coallition-flag"
                mdCol="12"
                name="superscore_calculated_by_act"
                values={formik.values.superscore_calculated_by_act}
                onChange={formik.handleChange}
                label="Superscore: Provide the Superscore calculated by ACT from your score report; do not calculate your own Superscore."
              />*/}

              <Grid xs={12}>
                <YesNoSwitch
                  id="is_report_highest_act_science_score"
                  className="mb-3"
                  label="Would you like to report your highest ACT Science score? *"
                  logo="span-cm-logo"
                  name="is_report_highest_act_science_score"
                  values={formik.values.is_report_highest_act_science_score}
                  onChange={formik.handleChange}
                  isMissing={!formik.values.is_report_highest_act_science_score && check}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              {/* {formik.values.have_taken_act_plus_writing_test === 'true' && ( */}
              <Grid xs={12}>
                <YesNoSwitch
                  id="is_report_highest_act_writing_score"
                  className="mb-3"
                  label="Would you like to report your highest ACT Writing score? *"
                  logo="span-cm-logo"
                  name="is_report_highest_act_writing_score"
                  values={formik.values.is_report_highest_act_writing_score}
                  onChange={formik.handleChange}
                  isMissing={!formik.values.is_report_highest_act_writing_score && check}
                  disabled={reviewedAndComplete}
                />
              </Grid>
              {/* )} */}

              <Grid xs={12}>
                <div className="text-field-light my-3" id="Composite"></div>
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TemplateScore
                  formik={formik}
                  highestLabel="Highest Composite Score*"
                  highestValuesName="highest_composite_score"
                  scoreValuesName="highest_composite_score_sub"
                  dateValuesName="highest_composite_test_day"
                  check={check}
                  readOnly={true}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TemplateScore
                  formik={formik}
                  highestLabel="Highest English Score*"
                  highestValuesName="highest_english_score"
                  scoreValuesName="highest_english_score_sub"
                  dateValuesName="highest_english_test_day"
                  check={check}
                  readOnly={true}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TemplateScore
                  formik={formik}
                  highestLabel="Highest Mathematics Score*"
                  highestValuesName="highest_mathematic_score"
                  scoreValuesName="highest_mathematic_score_sub"
                  dateValuesName="highest_mathematic_test_day"
                  check={check}
                  readOnly={true}
                />
              </Grid>

              <Grid xs={isMobile ? 12 : 6}>
                <TemplateScore
                  formik={formik}
                  highestLabel="Highest Reading Score*"
                  highestValuesName="highest_reading_score"
                  scoreValuesName="highest_reading_score_sub"
                  dateValuesName="highest_reading_test_day"
                  check={check}
                  readOnly={true}
                />
              </Grid>

              {formik.values.is_report_highest_act_science_score === 'true' && (
              <Grid xs={isMobile ? 12 : 6}>
                <TemplateScore
                  formik={formik}
                  highestLabel="Highest Science Score*"
                  highestValuesName="highest_science_score"
                  scoreValuesName="highest_science_score_sub"
                  dateValuesName="highest_science_test_day"
                  check={check}
                  readOnly={true}
                />
              </Grid>
              )}

              {formik.values.have_taken_act_plus_writing_test === 'true' && formik.values.is_report_highest_act_writing_score === 'true' && (
                <Grid xs={isMobile ? 12 : 6}>
                  <TemplateScore
                    options={optionValues2(11, 2).reverse()}
                    formik={formik}
                    highestLabel="Highest Writing Score*"
                    highestValuesName="highest_writing_score"
                    scoreValuesName="highest_writing_score_sub"
                    dateValuesName="highest_writing_test_day"
                    check={check}
                    readOnly={true}
                  />
                </Grid>
              )}

              <Grid xs={12}>
                <div className="text-field-light my-3" id="FutureACT"></div>
              </Grid>

              <Grid xs={12}>
                <div className={`text-field-mid ${isMobile ? 'fs-6' : 'fs-5'} p-1 mb-4`}>
                  Future ACT Tests You Plan To Take?
                </div>
              </Grid>

              <Grid xs={12}>
                <SelectInput
                  id="future_act_test_plan_to_take"
                  className="common-coallition-flag"
                  form={formik}
                  option={optionValues(Array.from(Array(4).keys()))}
                  label="Number of future ACT sittings you expect*"
                  name="future_act_test_plan_to_take"
                  values={formik.values.future_act_test_plan_to_take}
                  onChange={formik.handleChange}
                  isMissing={!formik.values.future_act_test_plan_to_take && check}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              {[1, '1', '2', '3', 2, 3].includes(formik.values.future_act_test_plan_to_take) && (
                <Grid xs={isMobile ? 12 : 6}>
                  <>
                    <DatePickerInput
                      id="future_testing_date_1_test1"
                      className="common-flag"
                      label={`Future testing date 1*`}
                      name="future_testing_date_1.test1"
                      values={formik.values?.future_testing_date_1?.test1}
                      onChange={(value) => formik.setFieldValue('future_testing_date_1.test1', value)}
                      isMissing={!formik.values?.future_testing_date_1?.test1 && check}
                      disabled={reviewedAndComplete}
                    />
                    {formik.errors?.future_testing_date_1?.test1 && 
                     formik.touched?.future_testing_date_1?.test1 && (
                      <div className="text-danger">{formik.errors.future_testing_date_1.test1}</div>
                    )}
                  </>
                </Grid>
              )}

              {['2', '3', 2, 3].includes(formik.values.future_act_test_plan_to_take) && (
                <Grid xs={isMobile ? 12 : 6}>
                  <>
                    <DatePickerInput
                      id="future_testing_date_1_test2"
                      className="common-flag end-flag"
                      label={`Future testing date 2*`}
                      name="future_testing_date_1.test2"
                      values={formik.values?.future_testing_date_1?.test2}
                      onChange={(value) => formik.setFieldValue('future_testing_date_1.test2', value)}
                      isMissing={!formik.values?.future_testing_date_1?.test2 && check}
                      disabled={reviewedAndComplete}
                    />
                    {formik.errors?.future_testing_date_1?.test2 && 
                     formik.touched?.future_testing_date_1?.test2 && (
                      <div className="text-danger">{formik.errors.future_testing_date_1.test2}</div>
                    )}
                  </>
                </Grid>
              )}

              {['3', 3].includes(formik.values.future_act_test_plan_to_take) && (
                <Grid xs={isMobile ? 12 : 6}>
                  <>
                    <DatePickerInput
                      id="future_testing_date_1_test3"
                      className="common-flag"
                      label={`Future testing date 3*`}
                      name="future_testing_date_1.test3"
                      values={formik.values?.future_testing_date_1?.test3}
                      onChange={(value) => formik.setFieldValue('future_testing_date_1.test3', value)}
                      isMissing={!formik.values?.future_testing_date_1?.test3 && check}
                      disabled={reviewedAndComplete}
                    />
                    {formik.errors?.future_testing_date_1?.test3 && 
                     formik.touched?.future_testing_date_1?.test3 && (
                      <div className="text-danger">{formik.errors.future_testing_date_1.test3}</div>
                    )}
                  </>
                </Grid>
              )}
            </Grid>

            <div className="row my-3 pt-3 mt-4 border-top">
              <div className="col-md-6">
                <div className="text-left pt-3">
                  <div className="gm-btn-checkmissing"
                    onClick={() => handleCheckMissing()}
                  >
                    <SearchIcon/><span>Check missing values</span>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}  
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-start text-md-end">
                <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <ModalCheckTestFields
          show={showModal}
          onClose={handleCloseModal}
          data={testData}
          page="act-test"
        />
      </Container>
    </>
  );
};

export default ACTTest;
